import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {lastValueFrom, Subscription} from 'rxjs';
import {ExcelAvance} from '../../../../_models/excel-avance';
import {NavService} from '../../../../_services/_nav.service';
import {UtilitiesService} from '../../../../utils/utilities.service';
import {TranslateService} from '@ngx-translate/core';
import {RxStompService} from '@stomp/ng2-stompjs';
import {AutenticacionService} from '../../../../_services/autenticacion.service';
import {Message} from '@stomp/stompjs';
import {SolicitudInversionService} from '../../../../_services/solicitud-inversion.service';
import {SolicitudInversion} from '../../../../_models/solicitud-inversion';

@Component({
  selector: 'app-widget-solicitud-inversion-pendiente',
  templateUrl: './widget-solicitud-inversion-pendiente.component.html',
  styleUrl: './widget-solicitud-inversion-pendiente.component.css'
})
export class WidgetSolicitudInversionPendienteComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  loadingTable: boolean = false;
  contador: number;
  columnas: any[] = [];
  showModalSolicitudes: boolean = false;
  numeroRegistros: number;
  page: string = '0';
  rowsPerPage: number = 10;
  filtroLazy: { cantidad: number, pagina: number };
  listSolicitudes: SolicitudInversion[] = [];
  formulario: FormGroup;
  modalVerificacion = {verificando: false, estActual: null, error: false, exitoso: 0};
  excelAvance: ExcelAvance;
  lanIntegracion: boolean = false;
  private topSubscription: Subscription;

  constructor(
    private navServicio: NavService,
    private solicitudInversionService: SolicitudInversionService,
    public utilitiesService: UtilitiesService,
    private translateService: TranslateService,
    private rxStompService: RxStompService,
    private authService: AutenticacionService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.contador = 0;
    this.columnas = [
      {field: 'idSolicitudInterno', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_NUMEROSOLICITUD'), sort: false, check: false},
      {field: 'fechasolicitud', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_FECHASOLICITUD'), sort: false, check: false},
      {field: 'codigoTipoDocumento', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_TIPODOCUMENTO'), sort: false, check: false},
      {field: 'numeroDocumento', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_NUMERODOCUMENTO'), sort: false, check: false},
      {field: 'nombreEstado', header: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_ESTADOSOLICITUD'), sort: false, check: false},
      {field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false, check: false}
    ];

    await this.cargarContador();
    this.conectarSocket();
    this.loading = false;
  }

  ngOnDestroy(): void {
    if (this.topSubscription) this.topSubscription.unsubscribe();
  }

  conectarSocket(): void {
    this.topSubscription = this.rxStompService.watch(`/topic/aprobacionSolicitudCdt${this.authService.obtenerIdUsuarioLogueado()}`).subscribe((message: Message) => {
      const body = (message && message.body) ? JSON.parse(message.body) : null;
      if (body && this.excelAvance && this.excelAvance.uid === body.uid) {
        this.excelAvance.avance = body.avance;
        this.excelAvance.errores = body.errores ? body.errores : [];
        this.excelAvance.totalRegistros = body.totalRegistros;
        if ((this.excelAvance.avance * 100) >= 100) {
          this.modalVerificacion.estActual = 'FINVER';
          this.modalVerificacion.error = this.excelAvance.errores.length > 0;
          this.modalVerificacion.exitoso = this.excelAvance.totalRegistros - this.excelAvance.errores.length
        }
      }
    });
  }

  async cargarContador(): Promise<void> {
    this.contador = await lastValueFrom(this.solicitudInversionService.getCountPendingStatus());
    this.rowsPerPage = !this.contador || this.contador == 0 ? 10 : this.contador;
  }

  visualizarIntegracionesFallidas(): void {
    this.showModalSolicitudes = true;
    this.filter();
  }

  async filter(event: any = null): Promise<void> {
    this.loadingTable = true;
    this.page = event ? String(event.first / this.rowsPerPage) : '0';
    const a = Object.assign({}, this.filtroLazy);
    a.pagina = Number(this.page);
    a.cantidad = this.rowsPerPage;

    this.solicitudInversionService.getPendingStatus(a).subscribe({
      next: (data) => {
        this.numeroRegistros = Number(data.totalPages);
        this.listSolicitudes = data.content;
        this.loadingTable = false;
        if (this.listSolicitudes.length === 0) {
          this.navServicio.setMesage(0, {
            severity: 'info',
            summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
            detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_NOEXISTENREGISTROS'),
          });
        }
      },
      error: err => {
        this.loadingTable = false;
        this.navServicio.setMesage(0, {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('LBL_ERROR'),
          detail: this.navServicio.buscarMensaje('MSG_ERRORCARGAR'),
        });
      }
    })
  }

  async actualizarUnico(solicitud: any): Promise<void> {
    this.loadingTable = true;
    const obj = {
      idSolicitud: solicitud.idSolicitud,
      numeroCuenta: solicitud.numeroCuenta
    };
    const mensajeActualizada: string | any = await lastValueFrom(this.translateService.get('WIDGETMODAL.MSG_CAMBIOSOLICITUD', { NUMSOLAHO: solicitud.idSolicitudInterno, value: 'actualizada' }));
    const mensajeFallida: string | any = await lastValueFrom(this.translateService.get('WIDGETMODAL.MSG_CAMBIOSOLICITUD', { NUMSOLAHO: solicitud.idSolicitudInterno, value: 'fallida' }));

    this.solicitudInversionService.pendingChangeStatus(obj).subscribe({
      next: (data) => {
        this.navServicio.setMesage(0, {
          severity: 'success',
          summary: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_TITLESOLICITUDEXITOSO'),
          detail: mensajeActualizada
        });
      },
      error: err => {
        this.navServicio.setMesage(0, {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('WIDGETMODAL.LBL_TITLESOLICITUDFALLIDA'),
          detail: mensajeFallida
        });
      },
      complete: async () => {
        this.loading = true;
        await this.cargarContador();
        this.loading = false;

        this.lanIntegracion = false;
        this.showModalSolicitudes = false;
        this.loadingTable = false;
      }
    });
  }

  async cerrarVerificacion(): Promise<void> {
    this.modalVerificacion.verificando = false;
    this.showModalSolicitudes = false;
    this.modalVerificacion.error = false;
    this.loading = true;
    await this.cargarContador();
    this.loading = false;
  }

  async actualizarContador(): Promise<void> {
    this.loading = true;
    await this.cargarContador();
    this.loading = false;
  }

  enviarActualizarTodo(): void {
    if (this.lanIntegracion) return;

    this.lanIntegracion = true;
    this.solicitudInversionService.pendingChangeStatusAll().subscribe({
      next: (data: ExcelAvance) => {
        this.modalVerificacion.estActual = 'INIT';
        this.excelAvance = data;
        this.lanIntegracion = false;
        this.modalVerificacion.verificando = true;
      },
      error: err => {
        this.navServicio.setMesage(0, {
          severity: 'error',
          summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
          detail: this.navServicio.buscarMensaje('WIDGETMODAL.MSG_ERRORINTEGRACIONES'),
        });
        this.lanIntegracion = false;
      }
    });
  }
}
